import { useIdleTimer } from 'react-idle-timer';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import { useRef } from 'react';
import { logoutUser } from '../pages/Auth/authThunks';

const IDLE_TIMEOUT = 3 * 60 * 60 * 1000;  // 30 minutes
const WARN_BEFORE  =  2 * 60 * 1000;  // warn 2 min before

const IdleTimerWrapper = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const warningShown = useRef(false);
  const modalRef = useRef(null);

  const logout = () => {
    if (modalRef.current) {
      modalRef.current.destroy();
      modalRef.current = null;
    }

    // ✅ Uses your existing logout flow — clears redux state,
    //    localStorage token, localStorage auth_info, sessionStorage
    dispatch(logoutUser()).finally(() => {
      navigate('/login');
    });
  };

  const { reset } = useIdleTimer({
    timeout: IDLE_TIMEOUT,
    onIdle: () => {
      logout();
    },
    onPrompt: () => {
      if (warningShown.current) return;
      warningShown.current = true;

      modalRef.current = Modal.warning({
        title: 'Session Expiring Soon',
        content: 'You have been idle for a while. You will be logged out in 2 minutes.',
        okText: 'Stay Logged In',
        onOk: () => {
          warningShown.current = false;
          reset();
        },
      });
    },
    promptBeforeIdle: WARN_BEFORE,
    events: [
      'mousemove',
      'keydown',
      'mousedown',
      'touchstart',
      'scroll',
      'wheel',
    ],
    throttle: 500,
    crossTab: true,
  });

  return children;
};

export default IdleTimerWrapper;